// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
import React from 'react';
import {Link as RRDLink} from 'react-router-dom';
import zurl from 'zurl';

export const Link = props=>{
    const href = props.to || props.href;
    const is_external = !!zurl.parse(href).host;
    const {children, ...other} = props;
    if (is_external)
        return <a href={href} {...other}>{children}</a>;
    return <RRDLink to={href} {...other}>{children}</RRDLink>;
};
